import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UtilitiesService } from 'src/app/shared/services/utilities/utilities.service';

@Component({
  selector: 'app-corporate-voucher-details',
  templateUrl: './corporate-voucher-details.component.html',
  styleUrl: './corporate-voucher-details.component.scss',
})
export class CorporateVoucherDetailsComponent {
  @Input() visible: boolean = false;
  @Input() data: any = {};
  @Output() popupClosed = new EventEmitter<void>();
  constructor(private readonly utilitiesService: UtilitiesService) {}

  public handlePopupClose(): void {
    this.popupClosed.emit();
  }

  public copyToClipboard(text: string): void {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        this.utilitiesService.showSwalWithToast(
          'Code Copied',
          '',
          'success',
          false,
          2000
        );
      })
      .catch((err) => {
        console.error('Failed to copy Code: ', err);
      });
  }
}
